import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import './LoginPage.css';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { service } = useParams();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setIsSubmitting(true);
      const API_URL = process.env.REACT_APP_API_URL || window.location.origin;
      const response = await axios.post(`${API_URL}/api/auth/request-reset`, { email });

      if (response.data.success) {
        setMessage(response.data.message);
        setEmail('');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="checkout-container-new" style={{minHeight:"100vh",background:"#0f0f0f",display:"flex",flexDirection:"column"}}>
      <header className="login-header" style={{flexShrink:0}}>
        <a href="https://openhosst.com" className="login-logo">
          <img src="/logo-dark.png" alt="OpenHosst" />
        </a>
      </header>

      <div className="email-entry-container">
        <div className="email-entry-card">
          <div className="icon-container" style={{marginBottom: '24px'}}>
            <i className="fa-solid fa-key" style={{fontSize: '48px', color: '#40E0D0'}}></i>
          </div>

          <h1 className="email-entry-title">Reset Your Password</h1>
          <p className="email-entry-subtitle" style={{marginBottom: '32px'}}>
            Enter your email address and we'll send you a link to reset your password
          </p>

          {error && (
            <div className="alert alert-error" style={{marginBottom: '20px'}}>
              <i className="fa-solid fa-circle-exclamation"></i> {error}
            </div>
          )}

          {message && (
            <div className="alert alert-success" style={{marginBottom: '20px', background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)', border: '1px solid #c3e6cb', color: '#155724'}}>
              <i className="fa-solid fa-circle-check"></i> {message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group-domain">
              <label className="form-label-new" htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                className="form-input-new"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                disabled={isSubmitting}
                style={{fontSize: '16px', padding: '14px 16px'}}
              />
            </div>

            <button
              type="submit"
              className="btn-continue"
              disabled={isSubmitting}
              style={{marginTop: '24px'}}
            >
              {isSubmitting ? (
                <>
                  <i className="fa-solid fa-spinner fa-spin"></i> Sending...
                </>
              ) : (
                <>
                  Send Reset Link
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{flexShrink: 0}}>
                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </>
              )}
            </button>
          </form>

          <p className="email-entry-note" style={{marginTop: '24px'}}>
            Remember your password? <button onClick={() => navigate(`/${service}`)} className="btn-link" style={{color: '#40E0D0', fontWeight: '600'}}>Back to Login</button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ForgotPasswordPage;
